/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { DataTransferMessageDirection } from '../model/dataTransferMessageDirection';
// @ts-ignore
import { DataTransferMessageR } from '../model/dataTransferMessageR';
// @ts-ignore
import { DataTransferMessageType } from '../model/dataTransferMessageType';
// @ts-ignore
import { IdType } from '../model/idType';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class DataTransferMessageService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param concernsIdType 
     * @param concernsId 
     * @param modifiedInterval 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminDataTransferMessageGetAllGet(concernsIdType: IdType, concernsId: string, modifiedInterval: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<DataTransferMessageR>>;
    public apiAdminDataTransferMessageGetAllGet(concernsIdType: IdType, concernsId: string, modifiedInterval: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<DataTransferMessageR>>>;
    public apiAdminDataTransferMessageGetAllGet(concernsIdType: IdType, concernsId: string, modifiedInterval: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<DataTransferMessageR>>>;
    public apiAdminDataTransferMessageGetAllGet(concernsIdType: IdType, concernsId: string, modifiedInterval: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (concernsIdType === null || concernsIdType === undefined) {
            throw new Error('Required parameter concernsIdType was null or undefined when calling apiAdminDataTransferMessageGetAllGet.');
        }
        if (concernsId === null || concernsId === undefined) {
            throw new Error('Required parameter concernsId was null or undefined when calling apiAdminDataTransferMessageGetAllGet.');
        }
        if (modifiedInterval === null || modifiedInterval === undefined) {
            throw new Error('Required parameter modifiedInterval was null or undefined when calling apiAdminDataTransferMessageGetAllGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (concernsIdType !== undefined && concernsIdType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>concernsIdType, 'concernsIdType');
        }
        if (concernsId !== undefined && concernsId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>concernsId, 'concernsId');
        }
        if (modifiedInterval !== undefined && modifiedInterval !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>modifiedInterval, 'modifiedInterval');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<Array<DataTransferMessageR>>(`${this.configuration.basePath}/api/admin/DataTransferMessage/GetAll`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param dataTransferMessageType 
     * @param dataTransferMessageDirection 
     * @param modifiedInterval 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminDataTransferMessageGetAllModifiedGet(dataTransferMessageType: DataTransferMessageType, dataTransferMessageDirection: DataTransferMessageDirection, modifiedInterval: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<DataTransferMessageR>>;
    public apiAdminDataTransferMessageGetAllModifiedGet(dataTransferMessageType: DataTransferMessageType, dataTransferMessageDirection: DataTransferMessageDirection, modifiedInterval: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<DataTransferMessageR>>>;
    public apiAdminDataTransferMessageGetAllModifiedGet(dataTransferMessageType: DataTransferMessageType, dataTransferMessageDirection: DataTransferMessageDirection, modifiedInterval: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<DataTransferMessageR>>>;
    public apiAdminDataTransferMessageGetAllModifiedGet(dataTransferMessageType: DataTransferMessageType, dataTransferMessageDirection: DataTransferMessageDirection, modifiedInterval: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (dataTransferMessageType === null || dataTransferMessageType === undefined) {
            throw new Error('Required parameter dataTransferMessageType was null or undefined when calling apiAdminDataTransferMessageGetAllModifiedGet.');
        }
        if (dataTransferMessageDirection === null || dataTransferMessageDirection === undefined) {
            throw new Error('Required parameter dataTransferMessageDirection was null or undefined when calling apiAdminDataTransferMessageGetAllModifiedGet.');
        }
        if (modifiedInterval === null || modifiedInterval === undefined) {
            throw new Error('Required parameter modifiedInterval was null or undefined when calling apiAdminDataTransferMessageGetAllModifiedGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (dataTransferMessageType !== undefined && dataTransferMessageType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dataTransferMessageType, 'dataTransferMessageType');
        }
        if (dataTransferMessageDirection !== undefined && dataTransferMessageDirection !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dataTransferMessageDirection, 'dataTransferMessageDirection');
        }
        if (modifiedInterval !== undefined && modifiedInterval !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>modifiedInterval, 'modifiedInterval');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<Array<DataTransferMessageR>>(`${this.configuration.basePath}/api/admin/DataTransferMessage/GetAllModified`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param concernsIdType 
     * @param concernsId 
     * @param modifiedTimestamp 
     * @param dataTransferMessageType 
     * @param dataTransferMessageDirection 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminDataTransferMessageGetGet(concernsIdType: IdType, concernsId: string, modifiedTimestamp: string, dataTransferMessageType: DataTransferMessageType, dataTransferMessageDirection: DataTransferMessageDirection, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<DataTransferMessageR>>;
    public apiAdminDataTransferMessageGetGet(concernsIdType: IdType, concernsId: string, modifiedTimestamp: string, dataTransferMessageType: DataTransferMessageType, dataTransferMessageDirection: DataTransferMessageDirection, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<DataTransferMessageR>>>;
    public apiAdminDataTransferMessageGetGet(concernsIdType: IdType, concernsId: string, modifiedTimestamp: string, dataTransferMessageType: DataTransferMessageType, dataTransferMessageDirection: DataTransferMessageDirection, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<DataTransferMessageR>>>;
    public apiAdminDataTransferMessageGetGet(concernsIdType: IdType, concernsId: string, modifiedTimestamp: string, dataTransferMessageType: DataTransferMessageType, dataTransferMessageDirection: DataTransferMessageDirection, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (concernsIdType === null || concernsIdType === undefined) {
            throw new Error('Required parameter concernsIdType was null or undefined when calling apiAdminDataTransferMessageGetGet.');
        }
        if (concernsId === null || concernsId === undefined) {
            throw new Error('Required parameter concernsId was null or undefined when calling apiAdminDataTransferMessageGetGet.');
        }
        if (modifiedTimestamp === null || modifiedTimestamp === undefined) {
            throw new Error('Required parameter modifiedTimestamp was null or undefined when calling apiAdminDataTransferMessageGetGet.');
        }
        if (dataTransferMessageType === null || dataTransferMessageType === undefined) {
            throw new Error('Required parameter dataTransferMessageType was null or undefined when calling apiAdminDataTransferMessageGetGet.');
        }
        if (dataTransferMessageDirection === null || dataTransferMessageDirection === undefined) {
            throw new Error('Required parameter dataTransferMessageDirection was null or undefined when calling apiAdminDataTransferMessageGetGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (concernsIdType !== undefined && concernsIdType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>concernsIdType, 'concernsIdType');
        }
        if (concernsId !== undefined && concernsId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>concernsId, 'concernsId');
        }
        if (modifiedTimestamp !== undefined && modifiedTimestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>modifiedTimestamp, 'modifiedTimestamp');
        }
        if (dataTransferMessageType !== undefined && dataTransferMessageType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dataTransferMessageType, 'dataTransferMessageType');
        }
        if (dataTransferMessageDirection !== undefined && dataTransferMessageDirection !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dataTransferMessageDirection, 'dataTransferMessageDirection');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<Array<DataTransferMessageR>>(`${this.configuration.basePath}/api/admin/DataTransferMessage/Get`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
